export default __webpack_public_path__ + "media/images/mailer-new/common/logo-footer-cc30d3bc70331c1899c7b0ee62e2cc4a.png";